// extracted by mini-css-extract-plugin
export default {"page":"nQ","freeShippingContainer":"oQ","customizeContainer":"pQ","customizeHeader":"qQ","fadein":"rQ","customizeText":"sQ","hidden":"tQ","productcard":"uQ","accordeonscontainer":"vQ","freeShipping":"wQ","mainpart":"xQ"};
    if(module.hot) {
      // 1743628927757
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  